import yup from '../../../config/yup';

export const delimitedReadValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('delimited'),
  properties: yup.object().shape({
    delimiter: yup.string(),
    header: yup.boolean(),
    inferSchema: yup.boolean(),
  }),
});

export const delimitedReadFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Delimited ID',
    },
    '@data-type': {
      type: 'string',
      title: 'Data Type',
      default: 'format',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'delimited',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        delimiter: {
          type: 'string',
          title: 'Delimiter',
        },
        header: {
          type: 'boolean',
          title: 'Header',
        },
        inferSchema: {
          type: 'boolean',
          title: 'Infer Schema',
        },
      },
    },
  },
  required: ['@id', '@data-type', 'name', 'type'],
};

export const delimitedReadFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated after saving',
  },
  '@data-type': {
    'ui:readonly': true,
  },
  type: {
    'ui:readonly': true,
  },
  header: {
    'ui:widget': 'checkbox',
  },
  inferSchema: {
    'ui:widget': 'checkbox',
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};

export const delimitedWriteValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('delimited'),
  properties: yup.object().shape({
    quoteAllFields: yup.boolean(),
    delimiter: yup.string(),
    header: yup.boolean(),
  }),
});

export const delimitedWriteFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Format ID',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'delimited',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        quoteAllFields: {
          type: 'boolean',
          title: 'Quote All Fields',
        },
        delimiter: {
          type: 'string',
          title: 'Delimiter',
        },
        header: {
          type: 'boolean',
          title: 'Header',
        },
      },
    },
  },
  required: ['name', 'type'],
};

export const delimitedWriteFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated',
  },
  type: {
    'ui:readonly': true,
  },
  quoteAllFields: {
    'ui:widget': 'checkbox',
  },
  header: {
    'ui:widget': 'checkbox',
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};
